import { TravelerPaxResponse, Loyalty, LoyaltyResponse } from '@pax/entities/traveler-pax';
import { TravelerItemUI, TravelerRoomUI } from '@pax/entities/pax-ui';

export function setDefaultWithNewLoyalty(entity: TravelerItemUI, payload: Loyalty): TravelerPaxResponse {
  const loyalty = entity?.defaultData?.loyalty?.map(loyaltyItem => ({
    ...loyaltyItem, isSelected: false
  }));
  return {
    ...entity.defaultData, loyalty: [
      ...loyalty, { ...payload, _id: null, isSelected: true }
    ]
  };
}

export function setDefaultWithNewLoyaltySelection(entity: TravelerItemUI, payload: LoyaltyResponse): TravelerPaxResponse {
  const loyalty = entity?.defaultData?.loyalty?.map(loyaltyItem => {
    const isSelected = loyaltyItem._id === payload._id;
    return { ...loyaltyItem, isSelected };
  });
  return {
    ...entity.defaultData, loyalty: [...loyalty]
  };
}

export function setDefaultWithSuccessLoyalty(entity: TravelerItemUI, response: LoyaltyResponse): TravelerPaxResponse {
  const loyalty = entity?.defaultData?.loyalty?.map(loyaltyItem => ({
    ...loyaltyItem, isSelected: false
  }));
  return {
    ...entity.defaultData, loyalty: [
      ...loyalty, { ...response, isSelected: true }
    ]
  };
}

export function setDefaultWithSuccessLoyaltyUpdate(entity: TravelerItemUI, response: LoyaltyResponse): TravelerPaxResponse {
  const loyaltyUpdateIndex = entity?.defaultData?.loyalty?.findIndex(item => item._id === response._id);
  const collection = entity.defaultData.loyalty.map(loyaltyItem => ({ ...loyaltyItem, isSelected: false }));
  if (loyaltyUpdateIndex < 0) return entity.defaultData;
  else {
    const loyaltyCollection = [
      ...collection.slice(0, loyaltyUpdateIndex),
      { ...response, isSelected: true },
      ...collection.slice(loyaltyUpdateIndex + 1)
    ];
    return {
      ...entity.defaultData, loyalty: [...loyaltyCollection]
    };
  }
}

export function setDefaultWithSuccessLoyaltyDelete(entity: TravelerItemUI, response: LoyaltyResponse): TravelerPaxResponse {
  const loyaltyDeleteIndex = entity?.defaultData?.loyalty?.findIndex(item => item._id === response._id);
  if (loyaltyDeleteIndex < 0) return entity.defaultData;
  else {
    const loyaltyCollection = [
      ...entity.defaultData.loyalty.slice(0, loyaltyDeleteIndex),
      ...entity.defaultData.loyalty.slice(loyaltyDeleteIndex + 1)
    ];
    return {
      ...entity.defaultData, loyalty: [...loyaltyCollection]
    };
  }
}

export function addPaxLoyalty(entity: TravelerPaxResponse, payload: LoyaltyResponse): LoyaltyResponse[] {
  return entity?.loyalty ? [
    ...entity.loyalty, { ...payload }
  ] : [];
}

export function editTravelerLoyaltyWithUpdate(entity: TravelerPaxResponse, payload: LoyaltyResponse): LoyaltyResponse[] {
  const index = entity?.loyalty?.findIndex(item => item._id === payload._id);
  if (index < 0) return entity.loyalty;
  else {
    const collection = entity?.loyalty ?[
      ...entity.loyalty.slice(0, index),
      {
        airline: payload.airline,
        number: payload.number,
        traveler: payload.traveler,
        _id: payload._id,
      },
      ...entity.loyalty.slice(index + 1)
    ] : [];
    return [...collection];
  }
}

export function editTravelerLoyaltyWithDelete(entity: TravelerPaxResponse, payload: LoyaltyResponse): LoyaltyResponse[] {
  const loyaltyDeleteIndex = entity?.loyalty?.findIndex(item => item._id === payload._id);
  if (loyaltyDeleteIndex < 0) return entity.loyalty;
  else {
    const loyaltyCollection = entity?.loyalty ? [
      ...entity.loyalty.slice(0, loyaltyDeleteIndex),
      ...entity.loyalty.slice(loyaltyDeleteIndex + 1)
    ] : [];
    return [...loyaltyCollection];
  }
}

export function setDefaultWithNewLoyaltyByGuest(entity: TravelerRoomUI, payload: Loyalty, guestId: number): TravelerPaxResponse {
  const guest = entity?.roomGuests?.[guestId];
  const loyalty = guest?.defaultData?.loyalty.map(loyaltyItem => ({
    ...loyaltyItem, isSelected: false
  }));
  return {
    ...guest?.defaultData, loyalty: [
      ...loyalty, { ...payload, _id: null, isSelected: true }
    ]
  };
}

export function setDefaultWithNewLoyaltySelectionByGuest(
  entity: TravelerRoomUI, payload: LoyaltyResponse, guestId: number
): TravelerPaxResponse {
  const guest = entity?.roomGuests?.[guestId];
  const loyalty = guest?.defaultData.loyalty.map(loyaltyItem => {
    const isSelected = loyaltyItem._id === payload._id;
    return { ...loyaltyItem, isSelected };
  });
  return {
    ...guest?.defaultData, loyalty: [...loyalty]
  };
}

export function setDefaultWithSuccessLoyaltyByGuest(
  entity: TravelerRoomUI, response: LoyaltyResponse, guestId: number
): TravelerPaxResponse {
  const guest = entity?.roomGuests?.[guestId];
  const loyalty = guest?.defaultData.loyalty.map(loyaltyItem => ({
    ...loyaltyItem, isSelected: false
  }));
  return {
    ...guest?.defaultData, loyalty: [
      ...loyalty, { ...response, isSelected: true }
    ]
  };
}

export function setDefaultWithSuccessLoyaltyDeleteByGuest(
  entity: TravelerRoomUI, response: LoyaltyResponse, guestId: number
): TravelerPaxResponse {
  const guest = entity?.roomGuests?.[guestId];
  const loyaltyDeleteIndex = guest?.defaultData.loyalty.findIndex(item => item._id === response._id);
  if (loyaltyDeleteIndex < 0) return guest?.defaultData;
  else {
    const loyaltyCollection = [
      ...guest.defaultData.loyalty.slice(0, loyaltyDeleteIndex),
      ...guest.defaultData.loyalty.slice(loyaltyDeleteIndex + 1)
    ];
    return {
      ...guest.defaultData, loyalty: [...loyaltyCollection]
    };
  }
}
export function setDefaultWithSuccessLoyaltyUpdateBuGuest(
  entity: TravelerRoomUI, response: LoyaltyResponse, guestId: number
): TravelerPaxResponse {
  const guest = entity?.roomGuests?.[guestId];
  const loyaltyUpdateIndex = guest.defaultData.loyalty.findIndex(item => item._id === response._id);
  const collection = guest.defaultData.loyalty.map(loyaltyItem => ({ ...loyaltyItem, isSelected: false }));
  if (loyaltyUpdateIndex < 0) return guest.defaultData;
  else {
    const loyaltyCollection = [
      ...collection.slice(0, loyaltyUpdateIndex),
      { ...response, isSelected: true },
      ...collection.slice(loyaltyUpdateIndex + 1)
    ];
    return {
      ...guest.defaultData, loyalty: [...loyaltyCollection]
    };
  }
}
